// extracted by mini-css-extract-plugin
export default {"preset_block":"style_preset_block__mJAFK","actions":"style_actions__a5+VV"};